import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Customer, CustomerState } from "src/types/customer.types";

const initialState: CustomerState = {
  list: { loading: false, data: null, error: null },
  create: { loading: false, data: null, error: null },
  edit: { loading: false, data: null, error: null },
  deleteCustomer: { loading: false, data: null, error: null },
};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    // 🧾 Fetch List
    getCustomersListRequest: (
      state,
      action: PayloadAction<{
        search?: string;
        page?: number;
        limit?: number;
      }>
    ) => {
      state.list.loading = true;
      state.list.error = null;
    },
    getCustomersListSuccess: (state, action: PayloadAction<any>) => {
      state.list.loading = false;
      state.list.data = action.payload;
    },
    getCustomersListError: (state, action: PayloadAction<string>) => {
      state.list.loading = false;
      state.list.error = action.payload;
    },

    // ➕ Create Customer
    createCustomerRequest: (state, action: PayloadAction<any>) => {
      state.create.loading = true;
      state.create.error = null;
    },
    createCustomerSuccess: (state, action: PayloadAction<Customer>) => {
      state.create.loading = false;
      state.create.data = action.payload;
    },
    createCustomerError: (state, action: PayloadAction<string>) => {
      state.create.loading = false;
      state.create.error = action.payload;
    },
    resetCustomerCreate: (state) => {
      state.create = { loading: false, data: null, error: null };
    },

    // ✏️ Edit Customer
    editCustomerRequest: (
      state,
      action: PayloadAction<{ id: string; data: Partial<Customer> }>
    ) => {
      state.edit.loading = true;
      state.edit.error = null;
    },
    editCustomerSuccess: (state, action: PayloadAction<Customer>) => {
      state.edit.loading = false;
      state.edit.data = action.payload;
    },
    editCustomerError: (state, action: PayloadAction<string>) => {
      state.edit.loading = false;
      state.edit.error = action.payload;
    },
    resetEditCustomer: (state) => {
      state.edit = { loading: false, data: null, error: null };
    },

    // 🗑️ Delete Customer
    deleteCustomerRequest: (state, action: PayloadAction<string>) => {
      state.deleteCustomer.loading = true;
      state.deleteCustomer.error = null;
    },
    deleteCustomerSuccess: (state, action: PayloadAction<any>) => {
      state.deleteCustomer.loading = false;
      state.deleteCustomer.data = action.payload;
    },
    deleteCustomerError: (state, action: PayloadAction<string>) => {
      state.deleteCustomer.loading = false;
      state.deleteCustomer.error = action.payload;
    },
    resetDeleteCustomer: (state) => {
      state.deleteCustomer = { loading: false, data: null, error: null };
    },
  },
});

export const {
  getCustomersListRequest,
  getCustomersListSuccess,
  getCustomersListError,
  createCustomerRequest,
  createCustomerSuccess,
  createCustomerError,
  resetCustomerCreate,
  editCustomerRequest,
  editCustomerSuccess,
  editCustomerError,
  resetEditCustomer,
  deleteCustomerRequest,
  deleteCustomerSuccess,
  deleteCustomerError,
  resetDeleteCustomer,
} = customerSlice.actions;

export default customerSlice.reducer;
